import React from "react";

const FinishLogo: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M33.633 8C41.03 8 46 15.264 46 22.04 46 35.763 25.373 47 25 47c-.373 0-21-11.237-21-24.96C4 15.264 8.97 8 16.367 8c4.246 0 7.023 2.218 8.633 4.168C26.61 10.218 29.387 8 33.633 8z"
      stroke="#8065C9"
      strokeWidth={3.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FinishLogo;
